import {
  ACTIVE_TIMER_STORAGE_KEY,
  AD_PERSONALIZATION_CONSENT_STORAGE_KEY,
  APP_SETTINGS_STORAGE_KEY,
  DATA_DISCLOSURE_CONSENT_STORAGE_KEY,
  FRICTION_START_STORAGE_KEY,
  FAVORITE_RESCUES_STORAGE_KEY,
  LEGAL_CONSENT_DONE_STORAGE_KEY,
  ONBOARDING_DONE_STORAGE_KEY,
  PARKING_DRAFT_STORAGE_KEY,
  RESCUE_SCRIPT_DRAFTS_STORAGE_KEY,
  STUCK_TIMER_HELPER_COUNT_STORAGE_KEY,
  TINY_WIN_DRAFT_STORAGE_KEY,
  UX_HINT_LEVEL_STORAGE_KEY
} from '../constants';
import type { AdConsentState } from './adConsent';
import { consentAllowsPersonalizedAds } from './adConsent';
import { AD_CAP_STORAGE_KEY } from './ads';
import { ENTITLEMENT_CACHE_KEY } from './monetization';

export const APP_LOCAL_STORAGE_KEYS = [
  ACTIVE_TIMER_STORAGE_KEY,
  FRICTION_START_STORAGE_KEY,
  TINY_WIN_DRAFT_STORAGE_KEY,
  PARKING_DRAFT_STORAGE_KEY,
  UX_HINT_LEVEL_STORAGE_KEY,
  STUCK_TIMER_HELPER_COUNT_STORAGE_KEY,
  ONBOARDING_DONE_STORAGE_KEY,
  LEGAL_CONSENT_DONE_STORAGE_KEY,
  DATA_DISCLOSURE_CONSENT_STORAGE_KEY,
  AD_PERSONALIZATION_CONSENT_STORAGE_KEY,
  APP_SETTINGS_STORAGE_KEY,
  RESCUE_SCRIPT_DRAFTS_STORAGE_KEY,
  FAVORITE_RESCUES_STORAGE_KEY,
  AD_CAP_STORAGE_KEY,
  ENTITLEMENT_CACHE_KEY
] as const;

type StorageLike = Pick<Storage, 'removeItem'>;

export function clearAppLocalState(storage: StorageLike = localStorage): void {
  for (const key of APP_LOCAL_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}

export function personalizedAdsEnabled(enabled: boolean, consent: AdConsentState): boolean {
  return enabled && consentAllowsPersonalizedAds(consent);
}
